import styled from '@emotion/styled';
import { LinePath } from '@visx/shape';
import { scaleTime, scaleLinear } from '@visx/scale';
import { ParentSize } from '@visx/responsive';
import { curveCardinal } from '@visx/curve';
import { dataColorRange } from './tokens/colors';
import type { ChartDateDatum } from '../features/chart/model';

const LINE_HEIGHT = 30;
const PADDING = 5;
const STROKE_WIDTH = 2;

const StyledParentSize = styled(ParentSize)`
  max-height: ${LINE_HEIGHT}px;
  overflow: hidden;
`;

export interface LineProps {
  data: ChartDateDatum[];
  stroke?: string;
}

export const Line = ({ data, stroke = dataColorRange[0].shade_400 }: LineProps): JSX.Element => {
  const xAccessor = (d: ChartDateDatum) => d.date;
  const yAccessor = (d: ChartDateDatum) => d.value ?? 0;

  const yScale = scaleLinear({
    range: [0 + PADDING, LINE_HEIGHT - PADDING],
    domain: [Math.max(...data.map(yAccessor)), 0],
  });

  return (
    <StyledParentSize>
      {(parent) => {
        const xScale = scaleTime({
          range: [0 + PADDING, parent.width - PADDING],
          domain: [data[0].date, data[data.length - 1].date],
        });
        return (
          <svg width={parent.width} height={LINE_HEIGHT}>
            <LinePath
              data={data}
              x={(d) => xScale(xAccessor(d))}
              y={(d) => yScale(yAccessor(d))}
              strokeWidth={STROKE_WIDTH}
              stroke={stroke}
              curve={curveCardinal}
            />
          </svg>
        );
      }}
    </StyledParentSize>
  );
};
